import React, { Component, useEffect, useState } from 'react'
import moment from 'moment'
import Pagination from '../../module/pagination-box'
import { commonActions, questionActions } from '../../store/actions'
import { connect } from 'react-redux'
import history from '../../route/history'
import { Link } from 'react-router-dom'

const QuestionList = (props) => {
  const queryString = require('query-string')
  const [cteCode, setCteCode] = useState(new Array(3))

  const [state, setState] = useState({
    schCode: 'TITLE',
    schText: '',
    cteCode: { cteCode },
    steCode: '',
    pageIdx: 0,
  })

  const [pagingInfo, setPagingInfo] = useState({})

  useEffect(() => {
    setState(state)
  }, [])

  useEffect(() => {
    props.getCommonCode({ mainCd: 'QNA_CATEGORY_CD' })
  }, [])

  useEffect(() => {
    setCteCode(props.cteCode)
  }, [props.cteCode])

  useEffect(() => {
    const parsed = queryString.parse(props.search)
    parsed.schText && !parsed.schCode && (parsed.schCode = 'TITLE')
    setState(parsed)
    props.load(parsed)
  }, [props?.search])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      let idx = state.pageIdx ? state.pageIdx : 0
      searchList(idx, true)
    }
  }

  const searchList = (index = 0, isEnforce = false) => {
    let searchInfo = {}
    const { schCode, schText, cteCode, steCode } = state
    ;(isEnforce === true || schText?.length > 0 || state.cteCode !== null) && (searchInfo = { schCode, schText, steCode, cteCode })
    index > 0 && (searchInfo.pageIdx = index)

    setState({
      ...state,
      pageIdx: index,
    })

    let paramStr = queryString.stringify(searchInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    history.push('/question' + paramStr)
  }

  useEffect(() => {
    setPagingInfo({
      totalRecords: props.question?.totalElements ? props.question?.totalElements : 0,
      currentPage: state.pageIdx ? parseInt(state.pageIdx) + 1 : 1,
      pageNumber: props.question?.pageable?.pageNumber,
      pagesToShow: 10,
      totalPages: props.totalPage,
    })
  }, [props.list])

  const goDetail = (seq, openYn = 'Y', mineYn = 'N') => {
    if (mineYn === 'Y') {
      history.push({ pathname: '/question/' + seq, state })
    } else if (openYn === 'N') {
      props.showPwdPopup(true, 'DETAIL', seq)
    } else {
      //props.showPwdPopup(false, 'DETAIL', seq);
      history.push({ pathname: '/question/' + seq, state })
    }
  }

  return (
    <React.Fragment>
      <div className="search-box inherit">
        <div className="row type2">
          <div className="sel-wrap">
            <span className="tit">카테고리</span>
            <select className="form-category3" name="cteCode" id="cteCode" value={state.cteCode} onChange={handleChange}>
              <option value="">전체</option>
              {cteCode?.map((item) => {
                return (
                  <option key={item.cd} value={item.cd}>
                    {item.cdName}
                  </option>
                )
              })}
            </select>
            <span className="tit">진행상태</span>
            <select className="form-category3" name="steCode" id="steCode" value={state.steCode} onChange={handleChange}>
              <option value="">전체</option>
              <option value="N">진행중</option>
              <option value="Y">답변완료</option>
            </select>
          </div>
          <div className="inquiry-wrap">
            <select className="form-category3" name="schCode" id="schCode" value={state.schCode} onChange={handleChange}>
              <option value="TITLE">제목</option>
              <option value="CONTENT">내용</option>
              <option value="ALL">제목+내용</option>
            </select>
            <div className="inquiry-group">
              <input
                type="text"
                className="form-keyword"
                placeholder="검색"
                id="schText"
                name="schText"
                value={state.schText || ''}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
              />
              <button
                type="button"
                className="btn-search"
                onClick={() => {
                  let idx = 0
                  searchList(idx, true)
                }}
              >
                검색
              </button>
            </div>
          </div>
        </div>
      </div>
      {props?.list?.length == 0 ? (
        <div className="row noData">
          <div className="cell">등록된 자료가 없습니다.</div>
        </div>
      ) : (
        <React.Fragment>
          <div className="list-header">
            <span className="total-num">
              현재페이지 <em>{pagingInfo?.currentPage}</em>/{pagingInfo?.totalPages} {pagingInfo?.totalPage} {pagingInfo?.totalRecords}건
            </span>
          </div>
          <div className="pc-only">
            <div className="tbl-wrap">
              <table className="tbl-list">
                <caption>번호, 카테고리, 제목, 진행상태, 작성자, 등록일, 조회 항목으로 구성</caption>
                <colgroup>
                  <col style={{ width: '7%' }} />
                  <col style={{ width: '10%' }} />
                  <col />
                  <col style={{ width: '9%' }} />
                  <col style={{ width: '9%' }} />
                  <col style={{ width: '9%' }} />
                  <col style={{ width: '9%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">번호</th>
                    <th scope="col">카테고리</th>
                    <th scope="col">제목</th>
                    <th scope="col">진행상태</th>
                    <th scope="col">작성자</th>
                    <th scope="col">등록일</th>
                    <th scope="col">조회</th>
                  </tr>
                </thead>
                <tbody>
                  {props.list?.map((question, index) => {
                    return (
                      <tr key={index} className="row">
                        <td>{question.questSeq}</td>
                        <td>{question.questCdName}</td>
                        <td className="tleft">
                          <button type="button" onClick={() => goDetail(question.questSeq, question?.openYn, question?.mineYn)}>
                            <span>
                              {question.questTitle}
                              {question.openYn === 'N' ? <i className="lock">잠김</i> : null}
                              {question.ptlFileDtoList?.length > 0 ? <i className="file">첨부파일</i> : null}
                            </span>
                          </button>
                        </td>
                        <td>{question.ansYn === 'Y' ? '답변완료' : '진행중'}</td>
                        <td>{question.regName}</td>
                        <td>{moment(question.regDt).format('YYYY.MM.DD')}</td>
                        <td>{question.viewCount}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mobile-only">
            <div className="list-view">
              {props.list?.map((question, index) => {
                return (
                  <div key={index} className="row" onClick={() => goDetail(question.questSeq, question?.openYn, question?.mineYn)}>
                    <div className="cell" data-title="번호">
                      {question.questSeq}
                    </div>
                    <div className="cell" data-title="카테고리">
                      {question.questCdName}
                    </div>
                    <div className="cell" data-title="제목">
                      <React.Fragment>
                        {question.questTitle}
                        {question.openYn === 'N' ? <i className="lock">잠김</i> : null}
                        {question.ptlFileDtoList?.length > 0 ? <i className="file">첨부파일</i> : null}
                      </React.Fragment>
                    </div>
                    <div className="cell" data-title="진행상태">
                      {question.ansYn === 'Y' ? '답변완료' : '진행중'}
                    </div>
                    <div className="cell" data-title="작성자">
                      {question.regName}
                    </div>
                    <div className="cell" data-title="등록일">
                      {moment(question.regDt).format('YYYY.MM.DD')}
                    </div>
                    <div className="cell" data-title="조회수">
                      {question.viewCount}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </React.Fragment>
      )}
      <div className="list-footer">
        <Pagination pagingInfo={pagingInfo} onChange={(param) => searchList(param - 1)} />
        <span className="right">
          <Link to="/questionwrite" className="btn-primary md">
            글쓰기
          </Link>
        </span>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    list: state.quest.data?.content,
    totalElements: state.quest.data?.totalElements,
    pageSize: state.quest.data?.size,
    totalPage: state.quest.data?.totalPages,
    pageNumber: state.quest.data?.pageable.pageNumber,
    cteCode: state.commoncode?.co?.QNA_CATEGORY_CD,
    question: state.quest?.data,
  }
}
const actionCreators = {
  load: questionActions.load,
  showTerms: questionActions.showTerms,
  showPwdPopup: questionActions.showPwdPopup,
  getCommonCode: commonActions.getCommonCode,
}

export default connect(mapStateToProps, actionCreators)(QuestionList)
